import gql from 'graphql-tag'

export const accountPaidQuery = gql`
	query($userFilter: UserFilter) {
		accountPaidQuery: allUsers(filter: $userFilter) {
			accountPaid
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/payment.js